import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import UserAvatar from '../../common/UserAvatar';
import { createEmailGroup, updateEmailGroup } from '../api';

const EmailGroupModal = ({ open, group, companyId, companyUsers, onClose, onSuccess }) => {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const isEdit = !!group;

    // Build user options for member multi-select
    const userOptions = (companyUsers?.data?.rows || []).map((u) => ({
        label: (
            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <UserAvatar name={u.name} userId={u.id} size={20} />
                {u.name}
            </span>
        ),
        value: u.id,
    }));

    useEffect(() => {
        if (open) {
            if (group) {
                form.setFieldsValue({
                    groupName: group.name,
                    subject: group.subject,
                    users: group.members?.map((m) => m.user_id || m.id) || [],
                });
            } else {
                form.resetFields();
            }
        }
    }, [open, group, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setSubmitting(true);

            if (isEdit) {
                await updateEmailGroup(companyId, group.id, {
                    name: values.groupName,
                    subject: values.subject,
                    users: values.users || [],
                });
                message.success('Email group updated');
            } else {
                await createEmailGroup(companyId, {
                    name: values.groupName,
                    subject: values.subject,
                });
                message.success('Email group created');
            }
            onSuccess();
        } catch (err) {
            if (err.errorFields) return;
            message.error(err.response?.data?.message || 'Failed to save email group');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title={isEdit ? 'Edit Email Group' : 'Add Email Group'}
            open={open}
            onCancel={onClose}
            onOk={handleSubmit}
            confirmLoading={submitting}
            destroyOnClose
            width={520}
        >
            <Form form={form} layout="vertical">
                <Form.Item name="groupName" label="Group Name" rules={[{ required: true, message: 'Group name is required' }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="subject" label="Email Subject" rules={[{ required: true, message: 'Subject is required' }]}>
                    <Input />
                </Form.Item>
                {isEdit && (
                    <Form.Item name="users" label="Members">
                        <Select
                            mode="multiple"
                            placeholder="Select members"
                            options={userOptions}
                            optionFilterProp="label"
                            maxTagCount="responsive"
                        />
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
};

export default EmailGroupModal;
